const s = {
  name: "AccountUpdater",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M2,20c0-9.9,8.1-18,18-18c5.3,0,10.1,2.3,13.4,6H26v2h10V0h-2v5.7C30.4,2.2,25.4,0,20,0C9,0,0,9,0,20H2z"/>
		<path class="st0" d="M20,40c11,0,20-9,20-20h-2c0,9.9-8.1,18-18,18c-5.3,0-10.1-2.3-13.4-6H14v-2H4v10h2v-5.7
			C9.6,37.8,14.5,40,20,40z"/>
		<path class="st0" d="M16,15c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4s-1.8,4-4,4C17.8,19,16,17.2,16,15z M20,13c-1.1,0-2,0.9-2,2
			s0.9,2,2,2c1.1,0,2-0.9,2-2S21.1,13,20,13z"/>
		<path class="st0" d="M14,26c0-1.7,1.3-3,3-3h6c1.7,0,3,1.3,3,3v2h2v-2c0-2.8-2.2-5-5-5h-6c-2.8,0-5,2.2-5,5v2h2V26z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as AccountUpdater
};
